import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form';
import { change } from 'redux-form';
import { Dropdown } from 'semantic-ui-react';
import { Utils } from '../../services';
import i18n from '../../locales/i18n';

const SETTING_FORM = 'settingForm';

const FilmSectionsField = ({ name, sectionBaseName, filmSectionOptions, isLoading }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    if (isLoading) {
        return <i className="fa fa-spinner fa-spin" />;
    }

    if (!filmSectionOptions) {
        return null;
    }

    const sourceLabel = (source) => {
        const key = `settings.mobile.screens.widget.settings.section_source_${source}`;
        const label = t(key);
        return label === key ? source : label;
    };

    const applySelection = (sectionId) => {
        if (!sectionId) {
            return;
        }

        const option = filmSectionOptions.find(o => o.id === sectionId);
        if (!option) {
            return;
        }

        dispatch(change(SETTING_FORM, `${sectionBaseName}.id`, sectionId));

        Utils.langs().forEach(lang => {
            const value = option.name?.[lang];
            if (value) {
                dispatch(change(SETTING_FORM, `${sectionBaseName}.${lang}`, value));
            }
        });
    };

    const Component = (props) => {
        const { input } = props;

        let options = filmSectionOptions.map(option => {
            const label = Utils.localized_or_fallback(option.name, i18n.language);
            return {
                key: option.id,
                text: `${label} (${sourceLabel(option.source)})`,
                value: option.id,
            };
        });

        if (input?.value && !options.some(o => o.value === input.value)) {
            options = options.concat({
                key: input.value,
                text: `[${t('common.unknown')} - ${input.value}]`,
                className: 'line-through',
                value: input.value,
            });
        }

        const onChange = (e, data) => {
            input.onChange(data.value);
            applySelection(data.value);
        };

        const valueProp = input.value === '' || input.value == null ? undefined : input.value;

        return (
            <Dropdown
                className="form-control"
                name={ name }
                options={ options }
                value={ valueProp }
                onChange={ onChange }
                placeholder={ t('settings.mobile.screens.widget.settings.section_choose') }
                fluid
                search
                selection
                scrolling
                clearable
                selectOnBlur={ false }
            />
        );
    };

    return (
        <div className="FilmSectionsField">
            <Field name={ name } component={ Component } />
        </div>
    );
};

export default FilmSectionsField;
